<template>
<div id="SalesWizardRecommendations" class="row">
    <div class="chart-segment-options align-items-start col-2">
        <modal-link modal-id="Wizard Options" :content-list="pageContent"></modal-link>
        <a href="#!" v-show="!displaySalesWizard" @click="handleToggle">Show Wizard Options<i class="fa fa-chevron-down ml-1"></i></a>
        <a href="#!" v-show="displaySalesWizard" @click="handleToggle">Hide Wizard Options<i class="fa fa-chevron-up ml-1"></i></a>
    </div>
    <div v-show="displaySalesWizard && !isVerbatimLocked" class="product-recommendations-section col-10">
        <div>
            <div class="product-recommendations-intro text-primary mb-3">
                Generate ideas on how to persuade individual respondents using their decision styles.
                Select which individuals (max 6) and which parts to include in your ideas.
            </div>
            <div class="chart-criteria-section-1-product-recommendations-section pb-2">
                <div class="chart-criteria-row">
                  <button type="button" class="btn btn-primary" :disabled="individualRespondents.length == 0" @click="displayIndividualRespondentsModal">
                    Individuals
                  </button>
                </div>
            </div>
            <div class="chart-criteria-section-1-product-recommendations-section pb-3">
                <div class="chart-criteria-row">
                    <div class="form-group">
                        <input id="includeValueGaps" name="includeValueGaps" type="checkbox" true-value="Y" false-value="N" v-model="includeValueGaps" />
                        <span class="ml-1 mr-3 mb-0">Include Value Gaps</span>
                    </div>
                    <div class="form-group">
                        <input id="includeExpectations" name="includeExpectations" type="checkbox" true-value="Y" false-value="N" v-model="includeExpectations" />
                        <span class="ml-1 mr-3 mb-0">Include Expectations</span>
                    </div>
                    <div class="form-group">
                        <input id="includePerformance" name="includePerformance" type="checkbox" true-value="Y" false-value="N" v-model="includePerformance" />
                        <span class="ml-1 mr-3 mb-0">Include Performance</span>
                    </div>
                    <div class="form-group">
                        <input id="includeWillingnessToPay" name="includeWillingnessToPay" type="checkbox" true-value="Y" false-value="N" v-model="includeWillingnessToPay" />
                        <span class="ml-1 mb-0">Include Willingness %s</span>
                    </div>
                </div>
                <div class="chart-criteria-row">
                    <div class="form-group">
                        <input id="includeVerbatims" name="includeVerbatims" type="checkbox" true-value="Y" false-value="N" v-model="includeVerbatims" />
                        <span class="ml-1 mr-3 mb-0">Include Verbatims</span>
                    </div>
                    <div class="form-group">
                        <input id="includeCompetitor" name="includeCompetitor" type="checkbox" true-value="Y" false-value="N" v-model="includeCompetitor" />
                        <span class="ml-1 mr-3 mb-0">Include Competitor</span>
                    </div>
                </div>
                <div class="chart-criteria-row">
                    <div class="form-group pl-0 pr-3">
                        <div class="d-flex align-items-center flex-nowrap">
                            <label class="sub-heading-label pr-2 m-0 text-nowrap text-primary"># of Ideas</label>
                            <div class="theme-select-width">
                                <select
                                id="numberOfRecommendations"
                                name="numberOfRecommendations"
                                class="custom-select shadow w-100"
                                v-model="numberOfRecommendations"
                                >
                                    <option value="0">Select</option>
                                    <option v-for="(option, idxNumberOfRecommendationOptions) in number_of_recommendation_options" v-bind:value="option.value" v-bind:key="idxNumberOfRecommendationOptions">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pl-0 pr-3">
                        <div class="d-flex align-items-center flex-nowrap">
                            <label class="sub-heading-label pr-2 m-0 text-nowrap text-primary">AI Toolset</label>
                            <div class="theme-select-width">
                                <select
                                id="salesWizardAiTypeId"
                                name="salesWizardAiTypeId"
                                class="custom-select shadow w-100"
                                v-model="salesWizardAiTypeId"
                                >
                                    <option v-for="(ai_type_option, idxAiTypeOptions) in ai_type_options" v-bind:value="ai_type_option.aiTypeId" v-bind:key="idxAiTypeOptions">
                                    {{ ai_type_option.displayName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
            <button class="btn btn-primary generate-recommendations-btn" @click="generateSalesWizardRecommendations" :disabled="(processInitiated && !processingComplete) || deactivateGeneratedThemesButton || oneTimeRunOnlyForInsiderUser || noInputSelected">
                <span>Analyze Individuals</span>
                <span v-show="processInitiated && !processingComplete" class="spinner-border spinner-border-sm"></span>
            </button>
            <div v-show="oneTimeRunOnlyForInsiderUser" class="form-row pt-1">
                <div v-show="oneTimeRunOnlyForInsiderUser" class="text-danger ml-2">Additional Recommendation Analysis is not active for your account. Contact your W Ratings Advisor or <a href="mailto:insider@wratings.com">insider@wratings.com</a> for more information.</div>
            </div>
            <div v-show="deactivateGeneratedThemesButton" class="form-row pt-1">
                <div v-show="deactivateGeneratedThemesButton" class="text-danger ml-2">Recommendation Analysis is not active for your account. Contact your W Ratings Advisor or <a href="mailto:insider@wratings.com">insider@wratings.com</a> for more information.</div>
            </div>
        </div> 
    </div>
    <!-- Response area -->
     <div v-show="displayIndividualSalesWizardChart()" id="sales-wizard-recommendations-container" class="chart-row pt-3">
        <profile-chart-header
          :title="'Decision Styles by Individual | ' + titleSuffix"
          :display="displayIndividualSalesWizardChart()"
          :content-list="contentList"
          :content-name="'Wizard Chart By Individual'"
          :display-download-comments="false"
          :display-show-respondents="false"
          :display-show-tooltip="false"
        />

        <individual-sales-wizard-chart
          ref="individualSalesWizardChart"
          :e-chart-mini-id="'individual-sales-wizard-chart-mini'"
          :e-chart-id="'individual-sales-wizard-chart'"
          :input-report-type-name="'Chart - Individual Sales Wizard'"
          :modal-id="'individual-sales-wizard-chart'"
          :is-saved-card="$parent.clientChart.clientChartId != 0"
          :input-client-chart="this.$parent.clientChart"
          :client-id="clientId"
          :company-color-list="companyColorList"
          :inputDownloadFileName="'Individual Sales Wizard - ' + titleSuffix"
          :input-individual-sales-wizard-data="individualSalesWizardData"
        />
    </div>
    <div class="row justify-content-center pt-4 w-100" v-show="showResults && displaySalesWizard">
        <div id="sales-wizard-recommendations-data-container" class="col-12">
            <div class="chart-header-container d-flex">
                <div class="d-flex title" style="padding-left: 0 !important;">
                  <modal-link modal-id="Wizard Ideas" :content-list="contentList" :image-size="'large'"></modal-link>
                <h4 class="text-primary mt-1 mb-0">
                    {{ title }}
                </h4>
                </div>          
            </div>
            <div class="d-none pt-2">
                <button type="button" class="btn btn-primary ml-auto" data-html2canvas-ignore="true" @click="$modal.show('print-instant-report-modal')">Save Report</button>
            </div>
            <div id="sales-wizard-results-container" class="chart-data"></div>
        </div>
    </div>
    <individual-respondents-modal
      :respondents="individualRespondents"
      :saved-selected-respondents="selectedRespondents"
      @save="handleIndividualRespondentsSave"
    />
</div>
</template>

<script>
import $ from "jquery";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ViewMixins from "../../mixins/ViewMixins.vue";
import ErrorService from "../../services/error.service";
import AIService from "../../services/ai.service";
import SurveyService from "../../services/survey.service";
import UserService from "../../services/user.service";
import AdminService from "../../services/admin.service";
import TableService from "../../services/table.service";
import ReportService from "../../services/report.service";
import IndividualRespondentsModal from "../../modals/IndividualRespondentsModal.vue";
import IndividualSalesWizardChart from "../../views/echarts/IndividualSalesWizardChart.vue";
import ProfileChartHeader from "../../components/echarts/ProfileChartHeader.vue";

export default {
  name: "SalesWizardRecommendations",
  mixins: [ContentMixins, ViewMixins],
  components: { IndividualRespondentsModal, IndividualSalesWizardChart,ProfileChartHeader },
  props: {
      clientObject: {
          type: Object,
          default: function() {
              return {};
          }
      },    
      clientChart: {
          type: Object,
          default: function() {
              return {};
          }
      },
      entrySurveyCode: {
          type: String,
          default: SurveyService.getSurveyCode()
      },
      criteriaResultsCompanyList: {
          type: Array,
          default: function() {
              return [];
          }
      },
      clientSettings: {
          type: Object,
          default: () => ({
              aiTypeId: null
          })
      },
      salesWizardData: {
          type: Object,
          default: () => null
      },
      contentList: {
          type: Array,
          default: function() {
              return [];
          }
      },
  },
  data() {
    return {
      title: "Decision Styles",
      displaySalesWizard: false,
      includeValueGaps: "Y",
      includeExpectations: "Y",
      includePerformance: "Y",
      includeWillingnessToPay: "Y",
      includeVerbatims: "Y",
      includeCompetitor: "Y",
      showResults: false,
      number_of_recommendation_options: [
        { label: "1", value: 1 },
        { label: "2", value: 2 },
        { label: "3", value: 3 },
        { label: "4", value: 4 },
        { label: "5", value: 5 },
        { label: "10", value: 10 }
      ],
      numberOfRecommendations: 0,
      salesWizardAiTypeId: 0,
      ai_type_options: [],
      topResults: [],
      topAttributeRecommendations: [],
      AUTO_SWITCH_LLM_MESSAGE: "Due to high demand, selected AI toolset could not complete your request. One or more results are generated using an alternate AI model.",
      processInitiated: false,
      processingComplete: true,  
      isSavedCard: false,
      summary: "",   
      table: {
        id: "sales-wizard-recommendations-data",
        class: "table display wrap row-border table-hover",
        configuration: {
            dom: '<"w-100"<"d-flex"><B>>frtip',      
            searching: false,
            paging: false,
            pageLength: 25,
            select: true,
            processing: false,
            responsive: false,
            destroy: true,
            info: false,
            order: [],
            ordering: false,
            keys: true,
            sort: false,
            bSortable: false,
            bSort: false,
            buttons: [],
        },
      },
      selectedRespondents: [],
      savedSurveyTakerAiTypeMap: {},
      savedCardAutoProcessPending: false,
      individualSalesWizardData: {
        rows: []
      },
      companyColorList: [],
      titleSuffix: ""
    };
  },
  computed: {
    noInputSelected() {
      return this.includeValueGaps == "N"
        && this.includeExpectations == "N"
        && this.includePerformance == "N"
        && this.includeWillingnessToPay == "N";
    },
    noOfRespondents: function() {
      let returnNumber = 0;
      let resultClientList = this.criteriaResultsCompanyList.find(x => x.type === "client");
      if (typeof resultClientList !== "undefined" && resultClientList.list.length > 0) {
        returnNumber = resultClientList.list[0].numberOfResults;
      }
      return returnNumber;
    },
    isVerbatimLocked() {
      return this.clientSettings.aiTypeId == 0;
    },
    individualRespondents() {
      if(this.salesWizardData && this.salesWizardData?.individualRespondents) {
        return this.salesWizardData.individualRespondents;
      }
      return [];
    },
  },
  mounted() {
    this.loadAITypes();
    this.setSalesWizardRecommendationValues(this.salesWizardData);
    this.displaySalesWizard = (this.isVerbatimLocked || !this.processInitiated) ? false : true;
  },
  methods: {
    setSalesWizardRecommendationValues(data) {
      if (data == null) {
        this.companyColorList = [];
        this.titleSuffix = "";
        return;
      }
      this.companyColorList = Array.isArray(data.companyColorList) ? JSON.parse(JSON.stringify(data.companyColorList)) : [];
      this.titleSuffix = data.titleSuffix || "";
    },
    displayIndividualSalesWizardChart() {
      return this.showResults && this.displaySalesWizard        
        && this.individualSalesWizardData.rows.length > 0;
    },
    convertSelectedIndividualRespondentsToSalesWizardData(selectedIndividualRespondents) {
      if (typeof selectedIndividualRespondents == "undefined" || selectedIndividualRespondents == null) {
        return { rows: [] };
      }
      return {
        rows: this.getIndividualSalesWizardRows(selectedIndividualRespondents)
      };
    },
    getIndividualSalesWizardRows(respondents) {
      if (typeof respondents == "undefined" || respondents == null) {
        return [];
      }
      return respondents.map(respondent => ({
        idealDecisionStyle: respondent.idealDecisionStyle,
        competitorDecisionStyle: respondent.competitorDecisionStyle,
        actualDecisionStyle: respondent.actualDecisionStyle,
        name: respondent.name,
        company: respondent.actualCompany,
        competitorCompany: respondent.competitorCompany
      }));
    },
    loadAITypes() {
        AIService.getAllActiveAITypes(this.setAITypeOptions);
    },
    setAITypeOptions(response) {
        this.ai_type_options = response;
        if (!this.isSavedCard && this.isMissingAiTypeId(this.salesWizardAiTypeId)) {
            this.setDefaultAiTypeIdFromClientSettings();
        }
    },
    isMissingAiTypeId(value) {
      return value == "" || value == null || value == 0;
    },
    getClientSettingsAiTypeId() {
      if (typeof this.clientSettings.aiTypeId != "undefined" && this.clientSettings.aiTypeId != null) {
        return this.clientSettings.aiTypeId;
      }
      return 0;
    },
    setDefaultAiTypeIdFromClientSettings() {
      const clientSettingsAiTypeId = this.getClientSettingsAiTypeId();
      if (!this.isMissingAiTypeId(clientSettingsAiTypeId)) {
        this.salesWizardAiTypeId = clientSettingsAiTypeId;
      }
    },
    handleToggle() {
      if (this.isVerbatimLocked) {
        AdminService.displayErrorMessage({
          text: "Wizard is not active for your organization. Contact your W Ratings Advisor for more information."
        });
        return;
      }
      this.displaySalesWizard = !this.displaySalesWizard;
    },
    buildInsightsParams() {
      let params = new URLSearchParams();
      params.append("client_id", this.clientObject.clientId);
      params.append("survey_id", SurveyService.getSurveyId());
      params.append("user_id", UserService.getUserId());
      params.append("include_value_gaps", this.includeValueGaps);
      params.append("include_expectations", this.includeExpectations);
      params.append("include_performance", this.includePerformance);
      params.append("include_willingness_to_pay", this.includeWillingnessToPay);
      params.append("include_verbatims", this.includeVerbatims);
      params.append("include_competitor", this.includeCompetitor);
      // params.append("chart_data", JSON.stringify(this.buildRecommendationsData()));
      params.append("number_of_recommendations", this.numberOfRecommendations);
      params.append("number_of_respondents", this.noOfRespondents);
      params.append("recommendations_ai_type_id", this.salesWizardAiTypeId);
      return params;
    },
    async generateSalesWizardRecommendations() {
      // if (this.noOfRespondents == null || this.noOfRespondents <= 0) {
      //     AdminService.displayErrorMessage({ text: "Please ensure there are respondents for the selected criteria before generating insights." });
      //     return;
      // }
      if (this.noInputSelected) {
          AdminService.displayErrorMessage({ text: "Please select at least one option - Value Gaps, Expectations, Performance, Willingness %s before generating insights." });
          return;
      }
      if (!Array.isArray(this.selectedRespondents) || this.selectedRespondents.length === 0) {
        this.displayIndividualRespondentsModal();
        return;
      }
      if (this.isMissingAiTypeId(this.salesWizardAiTypeId)) {
        this.setDefaultAiTypeIdFromClientSettings();
        if (this.isMissingAiTypeId(this.salesWizardAiTypeId)) {
          // AdminService.displayErrorMessage({ text: "Please select AI Toolset to generate recommendations." });
          return;
        }
      }
      this.processingComplete = false;
      this.processInitiated = true;
      this.showResults = false;
      this.destroySalesWizardTables();
      this.topResults = [];
      this.$root.processServerRequest("Generating Wizard Ideas");
      let params = this.buildInsightsParams();
      params.append("respondents_data", JSON.stringify(this.selectedRespondents));
      params.append("survey_taker_ai_type_map", JSON.stringify(this.savedSurveyTakerAiTypeMap));
      await AIService.generateSalesWizardRecommendations(params, this.generateSalesWizardCallback);
    },
    saveToCard: function() {
      let params = this.buildInsightsParams();
      params.append("survey_taker_ai_type_map", JSON.stringify(this.getSurveyTakerAiTypeMap()));
      params.append("auto_process_sales_wizard_by_ai", true);
      this.$emit("save-sales-wizard-criteria", params);
    },
    getSurveyTakerAiTypeMap() {
      const map = {};
      if (!Array.isArray(this.topResults)) {
        return map;
      }
      this.topResults.forEach(result => {
        if (result.SurveyTakerID != null && result.SurveyTakerResultsAiTypeId != null) {
          map[result.SurveyTakerID] = result.SurveyTakerResultsAiTypeId;
        }
      });
      return map;
    },
    loadCriteriaData() {
      let params = new URLSearchParams(this.clientChart.criteria);
      let autoProcessSalesWizardByAI = params.get("auto_process_sales_wizard_by_ai") || false;
      if (autoProcessSalesWizardByAI == "true" || autoProcessSalesWizardByAI == true) {
        this.includeValueGaps = params.get("include_value_gaps") || "Y";
        this.includeExpectations = params.get("include_expectations") || "Y";
        this.includePerformance = params.get("include_performance") || "Y";
        this.includeWillingnessToPay = params.get("include_willingness_to_pay") || "N";
        this.includeVerbatims = params.get("include_verbatims") || "N";
        this.includeCompetitor = params.get("include_competitor") || "N";
        this.numberOfRecommendations = Number(params.get("number_of_recommendations")) || 0;
        const criteriaAiTypeId = params.get("recommendations_ai_type_id");
        if (!this.isMissingAiTypeId(criteriaAiTypeId)) {
          this.salesWizardAiTypeId = criteriaAiTypeId;
        } else if (!this.isSavedCard) {
          this.setDefaultAiTypeIdFromClientSettings();
        }
        this.savedSurveyTakerAiTypeMap = this.parseSurveyTakerAiTypeMap(params.get("survey_taker_ai_type_map"));
        this.savedCardAutoProcessPending = true;
        this.restoreSelectedRespondentsFromSavedCriteria();
        this.displaySalesWizard = true;
        this.generateSalesWizardRecommendationsForSavedCard();
      }
    },
    parseSurveyTakerAiTypeMap(value) {
      try {
        return JSON.parse(value || "{}");
      } catch (e) {
        return {};
      }
    },
    restoreSelectedRespondentsFromSavedCriteria() {
      const map = this.savedSurveyTakerAiTypeMap || {};
      const respondents = this.salesWizardData?.individualRespondents || this.individualRespondents || [];
      this.selectedRespondents = respondents.filter(respondent =>
        map[respondent.surveyTakerId] != null
      );
    },
    generateSalesWizardRecommendationsForSavedCard() {
      if (!this.savedCardAutoProcessPending || this.selectedRespondents.length === 0) {
        return;
      }
      this.savedCardAutoProcessPending = false;
      this.generateSalesWizardRecommendations();
    },
    resetValues() {
      this.destroySalesWizardTables();
      this.showResults = false;
      this.displaySalesWizard = false;
      this.includeValueGaps = "Y";
      this.includeExpectations = "Y";
      this.includePerformance = "Y";
      this.includeWillingnessToPay = "Y";
      this.includeVerbatims = "Y";
      this.includeCompetitor = "Y";
      this.numberOfRecommendations = 0;
      if (typeof this.clientSettings.aiTypeId != "undefined" && this.clientSettings.aiTypeId != null){
        this.salesWizardAiTypeId = this.clientSettings.aiTypeId; 
      } else {
        this.salesWizardAiTypeId = 0; 
      }
      this.topResults = [];
      this.summary = "";
      this.isSavedCard = false;
      this.selectedRespondents = [];
      this.savedSurveyTakerAiTypeMap = {};
      this.savedCardAutoProcessPending = false;
    },
    generateSalesWizardCallback(response) {
      let statusCode = response.status;
      this.displaySalesWizard = true;
      if (statusCode == 200) {
                          
          const data = response.data.data || {};
          
          const response_ai_type_id = (data?.ai_type) ? (data?.ai_type.aiTypeId) : 0;
          if(response_ai_type_id != this.salesWizardAiTypeId && !this.isSavedCard) {
              AdminService.displayInfoMessage({ text: this.AUTO_SWITCH_LLM_MESSAGE}, { duration: 8000 }); // can be appended with - data?.ai_type.displayName 
          }
          this.salesWizardAiTypeId = response_ai_type_id;

          this.individualSalesWizardData = this.convertSelectedIndividualRespondentsToSalesWizardData(this.selectedRespondents);
          
          this.topResults = this.normalizeSalesWizardResults(data.topRecommendations || []);
          this.saveToCard();
          this.showResults = true;
          this.$nextTick(() => {
            this.initResultTables(this.topResults);
          });
		      this.isSavedCard = false;
          this.savedSurveyTakerAiTypeMap = {};
      } else {
          AdminService.displayErrorMessage({ text: response.data.message });
          this.showResults = false;
          this.initResultTables([]);
      }
      this.$root.processServerResponse();
      this.processInitiated = false;
      this.processingComplete = true;
      this.isSavedCard = false;
    },

    initResultTables(all = []) {
      this.destroySalesWizardTables();
      const results = this.normalizeSalesWizardResults(all);

      this.$nextTick(() => {
        const container = $("#sales-wizard-results-container");
        results.forEach((recommendation, idxRecommendation) => {
          const tableId = this.getSalesWizardTableId(idxRecommendation);
          const tableContainerId = tableId + "-container";
          const table = $("<table/>", {
            id: tableId,
            class: "sales-wizard-result-table table display wrap row-border table-hover",
            cellspacing: "0"
          });
          table.css("padding-left", "0");
          table.append(
            $("<thead/>", { class: "align-middle" }).append(
              $("<tr/>")
                .append($("<th/>", { class: "align-middle", text: "Strategic Dimensions" }))
                .append(
                  $("<th/>", { class: "align-middle" }).append(
                    $("<div/>", { class: "d-flex justify-content-between align-items-center" })
                      .append($("<span/>", { text: this.getSalesWizardResultTitle(recommendation) }))
                      .append($("<span/>", { class: "display-ai-type", text: " * Powered by " + this.getSalesWizardResultAiType(recommendation) }))
                  )
                )
            )
          );
          table.append($("<tbody/>"));

          const tableContainer = $("<div/>", {
            id: tableContainerId,
            class: "sales-wizard-result-table-container pt-3 pl-5"
          });
          tableContainer.append(table);
          container.append(tableContainer);

          const cfg = $.extend(true, {}, this.table.configuration, {
            data: this.getSalesWizardTableRows(recommendation),
            columns: [
              {
                data: "dimension",
                name: "dimension",
                width: "12rem",
                className: "dt-left align-top"
              },
              {
                data: "value",
                name: "value",
                width: "48rem",
                className: "dt-left align-top",
                render: function(data, type) {
                  if (type !== "display") {
                    return data;
                  }
                  return data || "";
                }
              }
            ],
            columnDefs: [
              {
                targets: 0,
                createdCell: function(td) {
                  $(td).css("font-weight", "600");
                }
              }
            ]
          });

          $.extend(
            cfg,
            TableService.getTableButtons(
              this,
              tableContainerId,
              undefined,
              undefined,
              false,
              this.getSalesWizardResultTitle(recommendation) || "Sales Wizard"
            )
          );

          $("#" + tableId).DataTable(cfg).columns.adjust().draw();
        });
      });
    },
    normalizeSalesWizardResults(results) {
      results = this.parseSalesWizardJsonIfNeeded(results);
      if (Array.isArray(results)) {
        return results.map(item => this.normalizeSalesWizardResultItem(item));
      }
      if (results == null || typeof results !== "object") {
        return [];
      }
      return Object.keys(results).reduce((list, surveyTakerId) => {
        const result = results[surveyTakerId];
        if (Array.isArray(result)) {
          result.forEach(item => list.push(this.normalizeSalesWizardResultItem(item, surveyTakerId)));
        } else {
          list.push(this.normalizeSalesWizardResultItem(result, surveyTakerId));
        }
        return list;
      }, []);
    },
    normalizeSalesWizardResultItem(result, surveyTakerId) {
      result = this.parseSalesWizardJsonIfNeeded(result);
      if (result == null || typeof result !== "object") {
        return {};
      }
      const topRecommendations = this.parseSalesWizardJsonIfNeeded(result.surveyTakerResults);
      const surveyTakerResultsAiType = this.formatSalesWizardAiType(result.surveyTakerResultsAiType);
      const surveyTakerResultsAiTypeId =
        result.surveyTakerResultsAiType?.aiTypeId ||
        result.SurveyTakerResultsAiTypeId ||
        result.surveyTakerResultsAiTypeId ||
        null;

      const resolvedSurveyTakerId =
        result.SurveyTakerID ||
        result.surveyTakerId ||
        surveyTakerId;

      if (Array.isArray(topRecommendations) && topRecommendations.length > 0) {
        const normalizedResult = this.normalizeSalesWizardResultItem(
          topRecommendations[0],
          resolvedSurveyTakerId
        );

        normalizedResult.SurveyTakerID =
          normalizedResult.SurveyTakerID || resolvedSurveyTakerId;

        normalizedResult.SurveyTakerResultsAiType =
          normalizedResult.SurveyTakerResultsAiType || surveyTakerResultsAiType;

        normalizedResult.SurveyTakerResultsAiTypeId =
          normalizedResult.SurveyTakerResultsAiTypeId || surveyTakerResultsAiTypeId;

        return normalizedResult;
      }
      if (topRecommendations != null && typeof topRecommendations === "object") {
        const normalizedResult = this.normalizeSalesWizardResultItem(
          topRecommendations,
          resolvedSurveyTakerId
        );

        normalizedResult.SurveyTakerID =
          normalizedResult.SurveyTakerID || resolvedSurveyTakerId;

        normalizedResult.SurveyTakerResultsAiType =
          normalizedResult.SurveyTakerResultsAiType || surveyTakerResultsAiType;

        normalizedResult.SurveyTakerResultsAiTypeId =
          normalizedResult.SurveyTakerResultsAiTypeId || surveyTakerResultsAiTypeId;

        return normalizedResult;
      }
      return {
        ...result,
        SurveyTakerID: resolvedSurveyTakerId,
        PrimaryDecisionStyle: result.PrimaryDecisionStyle,
        CompanyDecisionStyle: result.CompanyDecisionStyle,
        CompetitorDecisionStyle: result.CompetitorDecisionStyle,
        CompetitorBenchmark: result.CompetitorBenchmark,
        IncrementalGrowthPotential: result.IncrementalGrowthPotential,
        DecisionStyleAlignmentVulnerability: result.DecisionStyleAlignmentVulnerability,
        DataDrivenGapAnalysis: result.DataDrivenGapAnalysis,
        TailoredPersuasionStrategy: result.TailoredPersuasionStrategy,
        KeyWordsToUse: result.KeyWordsToUse,
        Recommendations: result.Recommendations || result.recommendations || result.recommendation,
        SurveyTakerResultsAiType: result.SurveyTakerResultsAiType || surveyTakerResultsAiType,
        SurveyTakerResultsAiTypeId: result.SurveyTakerResultsAiTypeId || surveyTakerResultsAiTypeId
      };
    },
    formatSalesWizardAiType(aiType) {
      if (aiType == null) {
        return "";
      }
      if (typeof aiType === "string") {
        return aiType;
      }
      let aiTypeName = aiType.vendor || aiType.displayName || "";
      if(aiTypeName != "") {
        return aiTypeName;
      }
      return "";
    },
    parseSalesWizardJsonIfNeeded(value) {
      if (typeof value !== "string") {
        return value;
      }
      const trimmedValue = value.trim();
      if (trimmedValue === "" || (trimmedValue.charAt(0) !== "{" && trimmedValue.charAt(0) !== "[")) {
        return value;
      }
      try {
        return JSON.parse(trimmedValue);
      } catch (e) {
        return value;
      }
    },
    getSalesWizardTableId(idxRecommendation) {
      return "sales-wizard-recommendations-table-" + idxRecommendation;
    },
    getSalesWizardResultTitle(recommendation) {
      if (recommendation == null) {
        return "";
      }
      return this.getSelectedRespondentName(recommendation.SurveyTakerID) || recommendation.SurveyTakerID || "";
    },
    getSalesWizardResultAiType(recommendation) {
      if (recommendation == null) {
        return "";
      }
      return recommendation.SurveyTakerResultsAiType || "";
    },
    getSelectedRespondentName(surveyTakerId) {
      if (!Array.isArray(this.selectedRespondents) || surveyTakerId == null) {
        return "";
      }
      const selectedRespondent = this.selectedRespondents.find(respondent => respondent.surveyTakerId == surveyTakerId);
      return selectedRespondent != null ? selectedRespondent.name : "";
    },
    getSalesWizardTableRows(recommendation) {
      if (recommendation == null) {
        return [];
      }
      return [
        { dimension: "Primary Decision Style", value: this.formatSalesWizardValue(recommendation.PrimaryDecisionStyle) },
        { dimension: "Company Decision Style", value: this.formatSalesWizardValue(recommendation.CompanyDecisionStyle) },
        { dimension: "Competitor Decision Style", value: this.formatSalesWizardValue(recommendation.CompetitorDecisionStyle) },
        { dimension: "Competitor Benchmark", value: this.formatSalesWizardValue(recommendation.CompetitorBenchmark) },
        { dimension: "Incremental Growth Potential", value: this.formatSalesWizardValue(recommendation.IncrementalGrowthPotential) },
        { dimension: "Decision Style Alignment & Vulnerability", value: this.formatSalesWizardValue(recommendation.DecisionStyleAlignmentVulnerability) },
        { dimension: "Tailored Persuasion Strategy", value: this.formatSalesWizardValue(recommendation.TailoredPersuasionStrategy) },
        { dimension: "Key Words to Use", value: this.formatSalesWizardkeyWordsToUse(recommendation.KeyWordsToUse) },
        { dimension: "Data-Driven Analysis", value: this.formatSalesWizardValue(recommendation.DataDrivenGapAnalysis) },
        { dimension: "Ideas", value: this.formatSalesWizardRecommendations(recommendation.Recommendations) }
      ];
    },
    formatSalesWizardValue(value) {
      if (value == null || value === "") {
        return "";
      }
      if (Array.isArray(value)) {
        return value.map(item => this.escapeHtml(String(item))).join("<br>");
      }
      return this.escapeHtml(String(value)).replace(/\n/g, "<br>");
    },
    formatSalesWizardkeyWordsToUse(value) {
      if (value == null || value === "") {
        return "";
      }
      if (Array.isArray(value)) {
        return value.map(item => this.escapeHtml(String(item))).join(" | ");
      }
      return this.escapeHtml(String(value)).replace(/\n/g, "<br>");
    },
    formatSalesWizardRecommendations(recommendations) {
      const formattedRecommendations = recommendations || [];
      
      if (!Array.isArray(formattedRecommendations)) {
        return this.formatSalesWizardValue(formattedRecommendations);
      }
      return formattedRecommendations
        // .map((item, index) => (index + 1) + ". " + this.escapeHtml(String(item)))
        .join("<br>");
    },
    escapeHtml(value) {
      return value;
        // .replace(/&/g, "&amp;")
        // .replace(/</g, "&lt;")
        // .replace(/>/g, "&gt;")
        // .replace(/"/g, "&quot;")
        // .replace(/'/g, "&#039;");
    },
    destroySalesWizardTables() {
      $(".sales-wizard-result-table").each(function() {
        const selector = "#" + this.id;
        if ($.fn.dataTable.isDataTable(selector)) {
          $(selector).DataTable().clear().destroy();
        }
      });
      $("#sales-wizard-results-container").empty();
    },
    destroyDt(selector) {
      if ($.fn.dataTable.isDataTable(selector)) {
        const dt = $(selector).DataTable();
        dt.clear();
        dt.destroy();
      }

      $(selector).find("tbody").empty();
    },
    async saveDataForInstantReport(clientReportId) {
        await this.$nextTick();
        const clientId = this.clientObject.clientId;
        const tableData = this.getRecommendationsTableData();

        await Promise.all([
            ReportService.saveReportTableFileForInstantReport(tableData, "Table - Sales Wizard", clientId, clientReportId, this.saveReportTableFileCallback, this),
            ReportService.saveInstantReportPage(clientId, TableService.getReportTableContentByTable("sales-wizard-results-container"), "Table - Sales Wizard", clientReportId, this.title, this.saveReportPageCallback, this)
        ]);
    },
    getRecommendationsTableData() {
        const tableData = [];
        $(".sales-wizard-result-table").each(function() {
          const selector = "#" + this.id;
          if ($.fn.dataTable.isDataTable(selector)) {
            tableData.push(...TableService.getTableData($(selector).DataTable()));
          }
        });
        return tableData;
    },
    displayIndividualRespondentsModal() {
      this.$modal.show("individual-respondents-modal");
    },
    handleIndividualRespondentsSave(selection) {
      this.selectedRespondents = selection.respondents;
    },
    
    loadSalesWizardData(data) {
      if(data?.individualRespondents) {
        this.individualRespondents = data.individualRespondents;
      }
    },
    saveReportTableFileCallback(response) {},
    saveReportPageCallback(response) {},
  },
  watch: {
    clientChart: function() {
      if (this.clientChart != null && this.clientChart.clientChartId > 0) {
        let params = new URLSearchParams(this.clientChart.criteria);
        this.isSavedCard = params.get("auto_process_sales_wizard_by_ai") === "true";

        if (this.isSavedCard) {
            this.displaySalesWizard = true;
            this.loadCriteriaData();
        } else {
            this.processingComplete = false;    
        }
      } else {
          this.resetValues();
          this.isSavedCard = false;
          this.processingComplete = false;
      }
    },
    clientSettings() {
      if (!this.isSavedCard && this.isMissingAiTypeId(this.salesWizardAiTypeId)) {
        this.setDefaultAiTypeIdFromClientSettings();
      }
    },
    salesWizardData: {
      handler(value) {
        this.setSalesWizardRecommendationValues(value);
        if (this.isSavedCard && this.savedCardAutoProcessPending) {
          this.restoreSelectedRespondentsFromSavedCriteria();
          this.generateSalesWizardRecommendationsForSavedCard();
        }
      },
      deep: true
    },
    entrySurveyCode: function(newVal, oldVal) {
      this.isSavedCard = false;
      this.resetValues();
    },
    
  }
};
</script>
